import { useEffect, useState } from "react";
import { ContainerFlex } from "../../../Components/Layout";
import useStatus from "../../../Hooks/Support/useStatus";
// import Filters from "./Filters";
import List from "./List";
import StatusModal from "./Modal";
const Status = () => {
  const { indexStatus } = useStatus();

  const [reload, setReload] = useState(true);

  const handleReload = () => {
    setReload(!reload);
  };

  useEffect(() => {
    indexStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  return (
    <ContainerFlex full padding="3">
      <List setReload={handleReload} />
      <StatusModal setReload={handleReload} />
    </ContainerFlex>
  );
};

export default Status;
